/* eslint-disable */

import easing from '../shaderlib/easing.glsl.js'
import noise from '../shaderlib/noise.glsl.js'
import rangeTranslation from '../shaderlib/rangeTranslation.glsl.js'

export default `
// -----------------------------------------------------------------------------
//
// Applies colors and stripe effect to shape layers.
//
// -----------------------------------------------------------------------------

struct Palette {
    vec3 c0;
    vec3 c1;
};

uniform Palette palettes[2];
uniform float time;
uniform float timeDelta;
uniform float timeMult;
uniform highp sampler2D uTexture;

varying float amount;
varying float gapNoise;
varying vec2 vUv;
varying vec2 jitter;

${easing}
${noise}
${rangeTranslation}

void main() {
    float gapCutoff = 0.2;
    float gapColorShift = translateNorm(gapCutoff, 1.0 + gapCutoff, gapNoise + gapCutoff);
    float blendTime = easeInOutQuart(
        translateNorm(
            -1.0,
            1.0,
            sin(timeDelta * timeMult)
        )
    );

    // palette0 and palette1 are each 2-color palettes. paletteBlend transitions
    // between those palettes over time
    vec3 palette0 = mix(palettes[0].c0.rgb, palettes[0].c1.rgb, gapColorShift);
    vec3 palette1 = mix(palettes[1].c0.rgb, palettes[1].c1.rgb, gapColorShift);
    vec3 paletteBlend = mix(palette0, palette1, (blendTime));

    // Mix paletteBlend with black using the intensity of sound as the factor
    vec3 color_out = mix(
        vec3(0.0),
        paletteBlend,
        amount
    );

    // Create gaps, stripes, and alpha falloff at the front and back
    float stripeSize = 256.0;
    if (vUv.y < 0.2) {
        stripeSize = 768.0;
    }
    float stripesAlpha = translateNorm(-1.0, 1.0, sin(vUv.y * PI2 * stripeSize));
    float falloffAlpha = easeInOutQuad(1.0 - abs((vUv.y - 0.5) * 2.0));
    float alpha = stripesAlpha * pow(gapNoise, 1.4) * falloffAlpha;

    gl_FragColor = vec4(color_out, alpha);

    // Set a hard cutoff for gapNoise values under a threshold
    if (gapNoise < gapCutoff) {
        discard;
    }
}
`;
